"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jul 23 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../core/conversions/DataObjectConverter");

var AppModule_1 = require("../core/modules/AppModule");

var SupplierOrderSuggestedConverter_1 = require("../supply/conversions/SupplierOrderSuggestedConverter");

var SupplierOrderSuggestedConverterImpl_1 = require("../supply/conversions/SupplierOrderSuggestedConverterImpl");

var SupplierOrderSuggestedHeaderConverter_1 = require("../supply/conversions/SupplierOrderSuggestedHeaderConverter");

var SupplierOrderSuggestedHeaderConverterImpl_1 = require("../supply/conversions/SupplierOrderSuggestedHeaderConverterImpl");

var ProductPreferredSupplierConverter_1 = require("./conversions/ProductPreferredSupplierConverter");

var ProductPreferredSupplierConverterImpl_1 = require("./conversions/ProductPreferredSupplierConverterImpl");

var ProductSecondarySupplierConverter_1 = require("./conversions/ProductSecondarySupplierConverter");

var ProductSecondarySupplierConverterImpl_1 = require("./conversions/ProductSecondarySupplierConverterImpl");

var ProductSuppliersConverter_1 = require("./conversions/ProductSuppliersConverter");

var ProductSuppliersConverterImpl_1 = require("./conversions/ProductSuppliersConverterImpl");

var ProductSuppliersGroupConverter_1 = require("./conversions/ProductSuppliersGroupConverter");

var ProductSuppliersGroupConverterImpl_1 = require("./conversions/ProductSuppliersGroupConverterImpl");

var SuppliedProductConverter_1 = require("./conversions/SuppliedProductConverter");

var SuppliedProductConverterImpl_1 = require("./conversions/SuppliedProductConverterImpl");

var SuppliedProductOverviewFilterConverter_1 = require("./conversions/SuppliedProductOverviewFilterConverter");

var SuppliedProductOverviewFilterConverterImpl_1 = require("./conversions/SuppliedProductOverviewFilterConverterImpl");

var SupplierAgreementConverter_1 = require("./conversions/SupplierAgreementConverter");

var SupplierAgreementConverterImpl_1 = require("./conversions/SupplierAgreementConverterImpl");

var SupplierAgreementPricesRecalcInputConverter_1 = require("./conversions/SupplierAgreementPricesRecalcInputConverter");

var SupplierAgreementPricesRecalcInputConverterImpl_1 = require("./conversions/SupplierAgreementPricesRecalcInputConverterImpl");

var SupplierAgreementUpdateDTOConverter_1 = require("./conversions/SupplierAgreementUpdateDTOConverter");

var SupplierAgreementUpdateDTOConverterImpl_1 = require("./conversions/SupplierAgreementUpdateDTOConverterImpl");

var SupplierConverter_1 = require("./conversions/SupplierConverter");

var SupplierConverterImpl_1 = require("./conversions/SupplierConverterImpl");

var SupplierPriceRecalculationConverter_1 = require("./conversions/SupplierPriceRecalculationConverter");

var SupplierPriceRecalculationConverterImpl_1 = require("./conversions/SupplierPriceRecalculationConverterImpl");

var SupplierSiteBindingConverter_1 = require("./conversions/SupplierSiteBindingConverter");

var SupplierSiteBindingConverterImpl_1 = require("./conversions/SupplierSiteBindingConverterImpl");

var SupplyConverter_1 = require("./conversions/SupplyConverter");

var SupplyConverterImpl_1 = require("./conversions/SupplyConverterImpl");

var SupplierAgreement_1 = require("./model/SupplierAgreement");
/**
 *
 * @author RV
 */


var SupplyAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(SupplyAppModule, _AppModule_1$AppModul);

  function SupplyAppModule() {
    var _this;

    _classCallCheck(this, SupplyAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplyAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'supplierAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SupplyAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ProductSuppliersGroupConverter_1.ProductSuppliersGroupConverter).to(ProductSuppliersGroupConverterImpl_1.ProductSuppliersGroupConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierConverter_1.SupplierConverter).to(SupplierConverterImpl_1.SupplierConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierAgreementConverter_1.SupplierAgreementConverter).to(SupplierAgreementConverterImpl_1.SupplierAgreementConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierAgreementPricesRecalcInputConverter_1.SupplierAgreementPricesRecalcInputConverter).to(SupplierAgreementPricesRecalcInputConverterImpl_1.SupplierAgreementPricesRecalcInputConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: SupplierAgreement_1.SupplierAgreement.name
      }).to(SupplierAgreementConverterImpl_1.SupplierAgreementConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierPriceRecalculationConverter_1.SupplierPriceRecalculationConverter).to(SupplierPriceRecalculationConverterImpl_1.SupplierPriceRecalculationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierAgreementUpdateDTOConverter_1.SupplierAgreementUpdateDTOConverter).to(SupplierAgreementUpdateDTOConverterImpl_1.SupplierAgreementUpdateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierSiteBindingConverter_1.SupplierSiteBindingConverter).to(SupplierSiteBindingConverterImpl_1.SupplierSiteBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplyConverter_1.SupplyConverter).to(SupplyConverterImpl_1.SupplyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SuppliedProductConverter_1.SuppliedProductConverter).to(SuppliedProductConverterImpl_1.SuppliedProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SuppliedProductOverviewFilterConverter_1.SuppliedProductOverviewFilterConverter).to(SuppliedProductOverviewFilterConverterImpl_1.SuppliedProductOverviewFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductPreferredSupplierConverter_1.ProductPreferredSupplierConverter).to(ProductPreferredSupplierConverterImpl_1.ProductPreferredSupplierConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSecondarySupplierConverter_1.ProductSecondarySupplierConverter).to(ProductSecondarySupplierConverterImpl_1.ProductSecondarySupplierConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSuppliersConverter_1.ProductSuppliersConverter).to(ProductSuppliersConverterImpl_1.ProductSuppliersConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierOrderSuggestedConverter_1.SupplierOrderSuggestedConverter).to(SupplierOrderSuggestedConverterImpl_1.SupplierOrderSuggestedConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierOrderSuggestedHeaderConverter_1.SupplierOrderSuggestedHeaderConverter).to(SupplierOrderSuggestedHeaderConverterImpl_1.SupplierOrderSuggestedHeaderConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return SupplyAppModule;
}(AppModule_1.AppModule);

exports.SupplyAppModule = SupplyAppModule;